import { commitMutation, Environment, graphql, type MutationConfig } from 'relay-runtime';

import { updateLearningInput, UpdateLearningMutation } from './__generated__/UpdateLearningMutation.graphql';

export const updateLearning = (
  environment: Environment,
  input: updateLearningInput,
  events: Pick<MutationConfig<UpdateLearningMutation>, 'onCompleted' | 'onError'>,
) => {
  return commitMutation<UpdateLearningMutation>(environment, {
    mutation: graphql`
      mutation UpdateLearningMutation($input: updateLearningInput!) {
        updateLearning(input: $input) {
          learning {
            id
            summary
            description
            lastEditedBy {
              pii {
                name
                picture
              }
            }
            lastEditedDate
            type
          }
        }
      }
    `,
    variables: { input },
    optimisticUpdater: store => {
      if (input.id) {
        const learning = store.get(input.id);

        if (input.summary) {
          learning?.setValue(input.summary, 'summary');
        }
        if (input.description) {
          learning?.setValue(input.description, 'description');
        }
      }
    },
    onCompleted: events.onCompleted,
    onError: events.onError,
  });
};
